import type RootState from 'app-components/utils/redux-store/rootState';

import { buildTransactionActionBatch } from './batchBuilder';
import { getTransactionActionCapabilityDefinition } from './capabilities';
import type { LaunchTransactionActionArgs, TransactionActionLaunchResult } from './proposalTypes';
import { getTransactionActionRunner } from './runners';

// Framework orchestrator: ties the batch builder, capability registry, and runner together into
// a single launch step (see "Expected End-To-End Flow" in
// docs/features/transaction-actions/README.md). This is the framework's entry point for "given
// launch args, what should happen" - executeTransactionAction.ts builds on top of this for
// structured-model capabilities that also need to make the AI request and parse a result.
export const buildTransactionActionLaunch = (
  state: RootState,
  args: LaunchTransactionActionArgs,
): TransactionActionLaunchResult => {
  const batch = buildTransactionActionBatch(state, args);
  const capabilityDefinition = getTransactionActionCapabilityDefinition(batch.capability);
  const runner = getTransactionActionRunner(capabilityDefinition.runnerId);

  return {
    batch,
    runnerId: capabilityDefinition.runnerId,
    runnerOutput: runner.buildOutput({ args, batch }),
  };
};
